import { useDocumentDetails } from 'hooks/useDocumentDetails';
import type { Document } from 'types';
import type { PlatDocumentType } from 'types/Documents';

export const usePlat = (id: string | null) =>
  useDocumentDetails<Document<PlatDocumentType> | null>(id);
